import { render, staticRenderFns } from "./404.vue?vue&type=template&id=20c508ae&scoped=true&"
var script = {}
import style0 from "./404.vue?vue&type=style&index=0&id=20c508ae&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c508ae",
  null
  
)

export default component.exports